import { useState } from 'react';
import { useGetListsActionPlan } from '@/hooks/v2/resolution-886';
import { useResolution886Report } from '@/context/Resolution886Report';
import { getReviewId } from '../../../_hooks/getReviewId';
import { Resolution886ActionPlanTask } from '@/constants/Resolution886';

export const useGetPreventiveMeasuresPaginated = () => {
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [limit] = useState<number>(10);

	const { selectedReviewId, report } = useResolution886Report();
	const organization_id = report?.organization?.id;
	const company_id = report?.company?.id;

	const reviewId = getReviewId(selectedReviewId, report?.reviews);

	const { data: actionPlan, isLoading } = useGetListsActionPlan({
		organization_id,
		company_id,
		review_id: reviewId,
		report_id: report?.id!
	});

	const transformedData =
		actionPlan?.rows?.map((item: any, index: number) => {
			const categoryResult = item.category_result;
			const actionPlanData = categoryResult.action_plan;

			const administrativeTask = actionPlanData?.tasks?.find((task: any) =>
				task.type === Resolution886ActionPlanTask.ADMINISTRATIVE
			);
			const engineeringTask = actionPlanData?.tasks?.find((task: any) =>
				task.type === Resolution886ActionPlanTask.ENGINEERING
			);

			return {
				number: index + 1,
				actionPlanName: actionPlanData?.title || '-',
				administrativeMeasure: administrativeTask?.title || '-',
				administrativeDueDate: administrativeTask?.due_date,
				engineeringMeasure: engineeringTask?.title || '-',
				engineeringDueDate: engineeringTask?.due_date,
				riskLevel: categoryResult.risk
			};
		}) || [];

	const startIndex = (currentPage - 1) * limit;
	const endIndex = startIndex + limit;
	const paginatedData = transformedData.slice(startIndex, endIndex);

	function handleOnChangePage(page: number): void {
		setCurrentPage(page);
	}

	return {
		actionPlanDataReview: transformedData,
		paginatedActionPlanData: paginatedData,
		currentPage,
		limit,
		setCurrentPage: handleOnChangePage,
		isLoading
	};
};
